/**
 * Created by matei on 16/11/2019
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { addToken } from '../../lib/utils/request';

import { authActionsFacade as authActions } from './../../actions/auth';
import { coursesActionsFacade as coursesActions } from './../../actions/courses';

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators(Object.assign({},
      authActions,
      coursesActions,
    ), dispatch),
  };
}

const mapStateToProps = (state) => ({
  courses: state.courses.courses,
});

@connect(mapStateToProps, mapDispatchToProps)
export default class AppContainer extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    courses: PropTypes.array,
  };

  static defaultProps = {
    courses: [],
  };

  constructor(props) {
    super(props);
    const {
      actions: {
        getUserProfile,
        getCourses,
      },
    } = props;

    const jwtToken = localStorage.getItem('jwtToken');

    this.state = {
      isLoaded: false,
      isCourseLoaded: false,
    };

    if (jwtToken) {
      addToken(jwtToken);

      getCourses().then(() => this.setState({
        isCourseLoaded: true,
      })).catch(() => this.setState({
        isCourseLoaded: true,
      }));
      getUserProfile().then(() => this.setState({
        isLoaded: true,
      })).catch(() => this.setState({
        isLoaded: true,
      }));
    } else {
      this.state = {
        isLoaded: true,
      };
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { courses, actions: { getCourses } } = this.props;

    if (this.state.isCourseLoaded && courses.length <= 0) {
      getCourses().then(() => this.setState({
        isCourseLoaded: true,
      })).catch(() => this.setState({
        isCourseLoaded: true,
      }));
    }
  }

  render() {
    const {
      children,
    } = this.props;
    const {
      isLoaded,
    } = this.state;

    return (
      <div className="appContainer">
        { isLoaded && children }
      </div>
    );
  }
}
